import { render, staticRenderFns } from "./QuatiRedefine.vue?vue&type=template&id=3e35d91d"
import script from "./QuatiRedefine.vue?vue&type=script&lang=js"
export * from "./QuatiRedefine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports